export enum HomepageInfoCardType {
  CLINICAL_TECHNOLOGY = 'CLINICAL_TECHNOLOGY',
  TESTIMONIAL = 'TESTIMONIAL',
  KNOW_ABOUT_DOCTORS = 'KNOW_ABOUT_DOCTORS',
}

export interface HomepageInfoCard {
  imageUrl: string;
  bannerText: string;
  bannerSubText: string;
  navigationLink: string;
  colSpan: 1 | 2;
  type: HomepageInfoCardType;
  rebrandedBannerText?: string;
  customStyling?: string;
}

export const RetentionRevampCardStyling = 'tw-aspect-3/4';

export const RetentionRevampCardOverrides: Partial<Record<HomepageInfoCardType, Partial<HomepageInfoCard>>> = {
  [HomepageInfoCardType.CLINICAL_TECHNOLOGY]: {
    imageUrl: '/assets/images/clinically_proven.png',
  },
};

export const HomepageInfoCardsData: Record<string, HomepageInfoCard[]> = {
  en: [
    {
      imageUrl: 'https://cdn.cureskin.com/app/img/treatment-philosophy/clinical_tech.png',
      bannerText: 'Our Clinically <br> Proven <br> Technologies',
      rebrandedBannerText: 'Our clinically <br> proven <br> technologies',
      bannerSubText: 'Rooted in scientific research',
      navigationLink: '/clinical-technology',
      colSpan: 2,
      type: HomepageInfoCardType.CLINICAL_TECHNOLOGY
    },
    {
      imageUrl: 'https://cdn.cureskin.com/app/img/treatment-philosophy/user_testimonials.png',
      bannerText: 'See what <br> our users <br> Say about us',
      bannerSubText: '',
      navigationLink: '/user/testimonialsNew',
      colSpan: 1,
      type: HomepageInfoCardType.TESTIMONIAL
    },
    {
      imageUrl: 'https://cdn.cureskin.com/app/img/treatment-philosophy/about_doctors.png',
      bannerText: 'Know about <br> Cure <br> doctors',
      rebrandedBannerText: 'Know about <br> Cure doctors',
      bannerSubText: '',
      navigationLink: '/doctors',
      colSpan: 1,
      type: HomepageInfoCardType.KNOW_ABOUT_DOCTORS
    }
  ],
  hi: [
    {
      imageUrl: 'https://cdn.cureskin.com/app/img/treatment-philosophy/clinical_tech.png',
      bannerText: 'हमारी क्लिनिकली <br> प्रूवेन टेक्नोलॉजीज़',
      bannerSubText: 'वैज्ञानिक रिसर्च पर आधारित, असरदार समाधान',
      navigationLink: '/clinical-technology',
      colSpan: 2,
      type: HomepageInfoCardType.CLINICAL_TECHNOLOGY
    },
    {
      imageUrl: 'https://cdn.cureskin.com/app/img/treatment-philosophy/user_testimonials.png',
      bannerText: 'हमारे उपयोगकर्ता <br> हमारे बारे में <br> क्या कहते हैं।',
      bannerSubText: '',
      navigationLink: '/user/testimonialsNew',
      colSpan: 1,
      type: HomepageInfoCardType.TESTIMONIAL
    },
    {
      imageUrl: 'https://cdn.cureskin.com/app/img/treatment-philosophy/about_doctors.png',
      bannerText: 'Cure के <br> डॉक्टरों के <br> बारे में जानें',
      bannerSubText: '',
      navigationLink: '/doctors',
      colSpan: 1,
      type: HomepageInfoCardType.KNOW_ABOUT_DOCTORS
    }
  ]
};

export const ClinicalTechnologyHighlights = {
  en: [
    {
      id: 0,
      title: `Sustained <br> Release Actives`,
      subTitle: `Advanced delivery technology that ensures continuous absorption of actives for longer-lasting efficacy without irritation.`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/release_actives.png',
    },
    {
      id: 1,
      title: `Bio-peptides`,
      subTitle: `Bio-mimetic ingredients that replicate naturally occurring peptides in the body and interact with targeted receptors in the skin.`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/bio_peptides.png',
    },
    {
      id: 2,
      title: `Anti-Inflammatory <br> Defense`,
      subTitle: `Add-ons to calm, neutralize oxidative stress and reduce inflammation and work with treatment specific actives.`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/anti_oxidant.png',
    },
    {
      id: 3,
      title: `Potent Cosmeceutical <br> Actives`,
      subTitle: `Compounds that go beyond cosmetics—combining pharmaceutical precision with visible benefits for both skin and hair.`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/cosmeceutical_actives.png',
    },
    {
      id: 4,
      title: `Prescription Strength`,
      subTitle: `Scientifically validated molecules prescribed in clinically relevant strengths, based on diagnosis and dermatologist review.`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/priscription_strength.png',
    },
  ],
  hi: [
    {
      id: 0,
      title: `धीरे-धीरे असर <br> करने वाले सक्रिय तत्व`,
      subTitle: `ऐडवांस डिलिवरी टेक्नोलॉजी जो सक्रिय तत्वों को धीरे-धीरे स्किन में सोखने देती है। इससे बिना किसी जलन के लंबे समय तक असर बना रहता है।`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/release_actives.png',
    },
    {
      id: 1,
      title: `बायो-पेप्टाइड्स`,
      subTitle: `ऐसे तत्व जो शरीर में प्राकृतिक रूप से पाए जाने वाले पेप्टाइड्स की नकल करते हैं और स्किन के ज़रूरी रिसेप्टर्स के साथ मिलकर असर दिखाते हैं।`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/bio_peptides.png',
    },
    {
      id: 2,
      title: `सूजन को कम <br> करने वाली सुरक्षा`,
      subTitle: `ऐसे अतिरिक्त तत्व जो स्किन को शांत करें, ऑक्सीडेटिव तनाव को कम करें और ट्रीटमेंट के मुख्य एक्टिव्स के साथ मिलकर बेहतर परिणाम दें।`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/anti_oxidant.png',
    },
    {
      id: 3,
      title: `शक्तिशाली <br> कॉस्मेस्युटिकल तत्व`,
      subTitle: `ऐसे तत्व जो सिर्फ कॉस्मेटिक नहीं, बल्कि दवा जैसी सटीकता और गहराई से काम करते हैं — जिससे स्किन और बालों दोनों में साफ़ बदलाव नजर आता है।`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/cosmeceutical_actives.png',
    },
    {
      id: 4,
      title: `चिकित्सकीय ताकत वाले तत्व`,
      subTitle: `साइंटिफिक रूप से प्रमाणित और डर्मेटोलॉजिस्ट की सलाह से चुने गए तत्व — जो आपकी समस्या की गंभीरता के हिसाब से असरदार मात्रा में दिए जाते हैं।`,
      image: 'https://cdn.cureskin.com/app/img/treatment-philosophy/priscription_strength.png',
    },
  ]
};
